import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class PriceSignService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createPriceSign(priceSign: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(priceSign);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/priceSigns"}`;
    return this.http.post(url, data, { headers });
  }

  updatePriceSign(priceSign: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(priceSign);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/priceSigns"}/${
      priceSign?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
